"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LazyInitArray = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2020 GoodData Corporation
var ts_invariant_1 = tslib_1.__importDefault(require("ts-invariant"));
/**
 * Simple implementation of fixed-size arrays with lazily initialized elements.
 */
var LazyInitArray = /** @class */ (function () {
    function LazyInitArray(size, initializer) {
        var _this = this;
        this.get = function (idx) {
            ts_invariant_1.default(idx >= 0 && idx < _this.data.length, "array index out of bounds: " + idx);
            if (!_this.data[idx]) {
                _this.data[idx] = _this.initializer(idx);
            }
            return _this.data[idx];
        };
        this[Symbol.iterator] = function () {
            var idx = 0;
            var length = _this.data.length;
            var get = _this.get;
            return {
                next: function () {
                    if (idx >= length) {
                        return {
                            done: true,
                            value: undefined,
                        };
                    }
                    var value = get(idx);
                    idx += 1;
                    return {
                        done: false,
                        value: value,
                    };
                },
            };
        };
        ts_invariant_1.default(size >= 0, "array size must be non-negative, got: " + size);
        this.data = new Array(size);
        this.initializer = initializer;
    }
    return LazyInitArray;
}());
exports.LazyInitArray = LazyInitArray;
//# sourceMappingURL=lazyInitArray.js.map